import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
export const Toggle = (props) => {
    const { checked, onToggleChanged } = props;
    const onClick = React.useCallback((e) => {
        onToggleChanged(!checked);
    }, [checked]);
    const backgroundColor = React.useMemo(() => checked ? '#C2FADF' : '#E0E9E0', [checked]);
    const marginLeft = React.useMemo(() => checked ? '1.175rem' : '0', [checked]);
    return (_jsx("div", { style: { width: '3rem', height: '1.8rem', borderRadius: '1.2rem', backgroundColor: backgroundColor, border: '0.24rem' + ' solid #BDCEBD', boxSizing: 'border-box', cursor: 'pointer', transition: 'background-color 0.1s linear' }, onClick: onClick, children: _jsx("div", { style: { width: '1.4rem', height: '1.4rem', borderRadius: '1rem', backgroundColor: '#839383', marginTop: `-0.02rem`, marginBottom: 0, marginLeft: marginLeft, transition: 'margin-left 0.1s linear', pointerEvents: 'none' } }) }));
};
//# sourceMappingURL=Toggle.js.map